import BaseRepository from './base.repository';

class GoalsRepository extends BaseRepository {
  constructor() {
    super('/goals');
  }

  getGoals(params) {
    return this.client.get('', params);
  }
}

export default new GoalsRepository();
